package org.gymly.util

private fun formatAmount(amount: Double): String {
    val scaled = kotlin.math.round(amount * 100).toLong()
    val intPart = scaled / 100
    val fracPart = kotlin.math.abs(scaled % 100).toInt()
    return "$intPart,${fracPart.toString().padStart(2, '0')}"
}

fun formatMoney(cents: Int, currency: String?): String {
    val cur = (currency ?: GymlyCurrency.CODE).uppercase()
    val formatted = formatAmount(cents / 100.0)
    return when (cur) {
        "VES" -> "${GymlyCurrency.SYMBOL} $formatted"
        "EUR" -> "$formatted €"
        "USD" -> "$${formatted.replace(',', '.')}"
        else -> "$formatted $cur"
    }
}

fun formatTime(time: String): String = time.take(5)

val weekdayShort: Map<Int, String> = mapOf(
    1 to "Lun", 2 to "Mar", 3 to "Mié", 4 to "Jue", 5 to "Vie", 6 to "Sáb", 7 to "Dom",
)

val weekdayLong: Map<Int, String> = mapOf(
    1 to "Lunes", 2 to "Martes", 3 to "Miércoles", 4 to "Jueves", 5 to "Viernes", 6 to "Sábado", 7 to "Domingo",
)

/** Días en inglés (mockup portal Horarios: "Monday · 05:00-06:00"). */
val weekdayLongEn: Map<Int, String> = mapOf(
    1 to "Monday", 2 to "Tuesday", 3 to "Wednesday", 4 to "Thursday", 5 to "Friday", 6 to "Saturday", 7 to "Sunday",
)

val weekdayShortEn: Map<Int, String> = mapOf(
    1 to "Mon", 2 to "Tue", 3 to "Wed", 4 to "Thu", 5 to "Fri", 6 to "Sat", 7 to "Sun",
)

val monthShortEn: Map<Int, String> = mapOf(
    1 to "Jan", 2 to "Feb", 3 to "Mar", 4 to "Apr", 5 to "May", 6 to "Jun",
    7 to "Jul", 8 to "Aug", 9 to "Sep", 10 to "Oct", 11 to "Nov", 12 to "Dec",
)

/** Formato mockup: "Mon 21 Jul · 05:00–06:00" */
fun formatPortalSessionLabel(sessionDate: String, weekday: Int, startTime: String, endTime: String): String {
    val dayName = weekdayShortEn[weekday] ?: ""
    val parts = sessionDate.trim().take(10).split("-")
    val dayNum = parts.getOrNull(2)?.toIntOrNull()?.toString() ?: sessionDate
    val month = parts.getOrNull(1)?.toIntOrNull()?.let { monthShortEn[it] } ?: ""
    return "$dayName $dayNum $month · ${formatTime(startTime)}–${formatTime(endTime)}"
}

val paymentMethodLabel: Map<String, String> = mapOf(
    "MOBILE_PAYMENT" to "Pago móvil",
    "TRANSFER" to "Transferencia",
    "ZELLE" to "Zelle",
    "USDT" to "USDT",
)
